import styled from '@emotion/styled'
import {
  IonCard,
  IonCardContent,
  IonCardHeader, IonCardTitle,
  IonCol,
  IonIcon,
  IonImg,
  IonNote,
  IonRow,
  IonSpinner,
  IonGrid,
  IonText,
  Animation,
  CreateAnimation, IonCardSubtitle,
  createAnimation, IonLoading, IonToolbar, IonTitle, IonButtons, IonButton
} from '@ionic/react'
import "../../theme/variables.css"
import ScreenWakeLock from 'screen-wake-lock';
import Wrapper from "../../components/Header/Wrapper"
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {useLocation, useParams, useSearchParams} from 'react-router-dom'
import { getSlideshowData } from '../../util/api/Slideshow'
import {getEndPoint, SLIDESHOW} from "../../util/api/enpoints";
import {fetchEventData, setAuctionCode, setEventCode} from "../../redux/slices/eventSlice";
import {setPrivacyEventCode} from "../../redux/slices/privacyPolicySlice";
import userEvent from "@testing-library/user-event";
import moment from "moment";
import {HubConnection, HubConnectionBuilder, JsonHubProtocol, LogLevel} from "@microsoft/signalr";
import {
  fetchSlideshowItemsData, updateActiveAuctionItems,
  updateActiveItem,
  updateSlideshowItemOnBid
} from "../../redux/slices/slideShowItemSlice";
import store from "../../redux/store";
import SlideshowDetailPage from "./SlideshowDetailPage";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Img from "../../components/Header/Img";
import {expandOutline} from "ionicons/icons";
import {getConfig} from "../../AppConfig";
import {DateTime} from "luxon";

interface Params {
  eventcode: string,
  location?: string,
  timeframe?: string
  // list?: string
  pagecount?: string
}

const { apiUrl } = getConfig()
const PROD_URL = apiUrl + "/hubs/auction"

const SlideshowPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { eventcode, locationParam, timeframeParam, pagecountParam } = useParams()
  const [pagecount, setpagecount] = React.useState('')
  const [timeframe, settimeframe] = React.useState('')
  const [location, setlocation] = React.useState('')
  const [loading, setloading] = React.useState(true)
  const [auctionItems, setAuctionItems] = React.useState([])

  useEffect(() => {
    if (searchParams.get('timeframe')) {
      settimeframe(searchParams.get('timeframe'))
    }
    else {
      settimeframe(timeframeParam)
    }
    var tempLocation = locationParam
    if (searchParams.get('location')) {
      setlocation(searchParams.get('location'))
      tempLocation = searchParams.get('location')
    }
    else {
      setlocation(locationParam)
    }
    if (searchParams.get('pagecount')) {
      setpagecount(searchParams.get('pagecount'))
    }
    else {
      setpagecount(pagecountParam)
    }
    // console.log(searchParams.get('timeframe'))
    // console.log(searchParams.get('location'))
    // console.log(searchParams.get('pagecount'))

    var url = getEndPoint(SLIDESHOW)  + '/' + auctioncode + '/' + eventcode
    if (tempLocation) {
      url += '/' + tempLocation
    }
    const getData = async () => {
      const slideShowData = await store.dispatch(fetchSlideshowItemsData(url))
      console.log(slideShowData.payload.auctionitems)
      if (slideShowData.payload.auctionitems) {
        setAuctionItems(slideShowData.payload.auctionitems)
      }
      else {
        setAuctionItems([])
      }

      setloading(false)
    }
    getData()

  }, [])

  const handle = useFullScreenHandle();
  let uriLocation = useLocation();
  const list = uriLocation.pathname.includes('/list')
  const animationRef = useRef < HTMLIonCardElement >();

  const dispatch = useDispatch()
  const [message, setMessage] = useState<string | undefined>(undefined)
  const [lstMessage, setListMessage] = useState<string | undefined>(undefined)

  const domainName =  window.location.hostname
  const domainNames = domainName.split('.')
  const auctioncode = (domainNames && domainNames.length > 0) ? domainNames[0] : 'app'

  const slideshowStateItems = useSelector((state: any) => state.slideshowItems);
  const auctionStateItems = useSelector((state: any) => state.slideshowItems.auctionitems);
  const activeStateItem = useSelector((state: any) => state.slideshowItems.activeItem);
  const eventData = useSelector((state: any) => state.event)


  useEffect(() => {
    const url = getEndPoint('EVENT_ENDPOINT')
    const eventData = {
      url,
      eventcode: eventcode,
      auctioncode: auctioncode
    }
    dispatch(fetchEventData(eventData))
    dispatch(setEventCode(eventcode))
    dispatch(setAuctionCode(auctioncode))
    dispatch(setPrivacyEventCode(eventcode))
  }, [eventcode, auctioncode])


  async function start(connection: any) {
    try {
      await connection.start();
    } catch (err) {
      console.log(err);
    }
  };

  const currencyFormat = (num: Number) => {
    return '$' + num.toFixed(0) //.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  useEffect(() => {
    // localStorage.setItem("token", slideshowStateItems.token)
    let connection: HubConnection

    const token = slideshowStateItems.token
    if (token) {
      connection =  new HubConnectionBuilder()
          .withUrl(PROD_URL, { accessTokenFactory: () => { return token as string } })
          .withAutomaticReconnect()
          .withHubProtocol(new JsonHubProtocol())
          .configureLogging(LogLevel.Debug)
          .build()

      connection?.on("ReceiveJSON", (msg: any) => {
        const parsedData = JSON.parse(msg.jsonString)
        console.log(parsedData)
        if (parsedData.type === 'itemupdate') {
          store.dispatch(
              updateSlideshowItemOnBid({
                ...parsedData
              })
          )
        }
      })

      start(connection);
    }
    // setSlideShowRecs(slideshowStateItems.auctionitems)
  }, [slideshowStateItems.auctionitems])

  useEffect(() => {
    let imageIndex = 0;
    let currentListItemCount = 0
    const listItemsCount = (Number(pagecount) > 0 ? Number(pagecount) : 6);
    const duration = Number((Number(timeframe) > 0 ? Number(timeframe) * 1000 : 10000))


    const currentListArray = auctionStateItems?.slice(currentListItemCount, currentListItemCount+listItemsCount)
    if (currentListArray && (currentListArray.length + currentListItemCount) >= auctionStateItems.length) {
      currentListItemCount = 0
    }
    else {
      currentListItemCount += listItemsCount
    }
    store.dispatch(updateActiveAuctionItems(currentListArray))

    if ((!list && auctionStateItems && auctionStateItems.length > 0) || (auctionStateItems && auctionStateItems.length >= listItemsCount && list)) {
      const imageInterval = setInterval(() => {
        // handleEndPlayAnimation()
        if (imageIndex < auctionStateItems?.length - 1) {
          imageIndex += 1;

          const currentListArray = auctionStateItems.slice(currentListItemCount, currentListItemCount+listItemsCount)
          if (currentListArray && (currentListArray.length + currentListItemCount) >= auctionStateItems.length) {
            currentListItemCount = 0
          }
          else {
            currentListItemCount += listItemsCount
          }
          store.dispatch(updateActiveAuctionItems(currentListArray))
        } else {
          imageIndex = 0;
        }
        store.dispatch(updateActiveItem(auctionStateItems[imageIndex]))
        handleBeginPlayAnimation()
      }, duration);
      return () => clearInterval(imageInterval);
    }
  }, [auctionStateItems]);

  var local = DateTime.local()
  const centralBiddingClosed = DateTime.fromISO(eventData.eventbiddingclosedcst, {zone: 'America/Chicago'});
  const localDateBiddingClosed = centralBiddingClosed.setZone(local.zoneName)
  const localDateBiddingClosedString = localDateBiddingClosed.toString()

  useEffect(() => {

    // const interval = setInterval(() => {
    if (eventData?.eventbiddingclosedcst && eventData?.eventbiddingclosedcst?.length > 0) {
      const checkThen: any = moment(localDateBiddingClosedString)
      const checkNow: any = moment()
      const checkCalcSeconds = checkThen.diff(checkNow, 'seconds')
      const checkDays        = Math.floor(checkCalcSeconds/24/60/60);
      const checkHoursLeft   = Math.floor((checkCalcSeconds) - (checkDays*86400));
      const checkHours       = Math.floor(checkHoursLeft/3600);

      if (checkCalcSeconds > 1) {
        const interval = setInterval(() => {
          const then: any = moment(localDateBiddingClosedString)
          const now: any = moment()
          // tslint:disable-next-line

          const calcSeconds = then.diff(now, 'seconds')
          const days = Math.floor(calcSeconds / 24 / 60 / 60);
          const hoursLeft = Math.floor((calcSeconds) - (days * 86400));
          const hours = Math.floor(hoursLeft / 3600);
          const minutesLeft = Math.floor((hoursLeft) - (hours * 3600));
          const minutes = Math.floor(minutesLeft / 60);
          const remainingSeconds = calcSeconds % 60;

          function pad(n) {
            return (n < 10 ? "0" + n : n);
          }

          console.log(pad(days) + ":" + pad(hours) + ":" + pad(minutes) + ":" + pad(remainingSeconds))
          debugger

          // Countdown
          var messageString = ''
          if (days > 0) {
            messageString += pad(days) + "d "
            setListMessage(pad(days) + "d " + pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
          }
          if (hours > 0) {
            messageString += pad(hours) + "h "
            // setMessage(pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
            setListMessage(pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
          }
          if (minutes > 0) {
            messageString += pad(minutes) + "m "
            // setMessage(pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
            setListMessage(pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
          }
          if (remainingSeconds > 0) {
            messageString += pad(remainingSeconds) + "s "
            // setMessage(pad(remainingSeconds) + 's')
            setListMessage(pad(remainingSeconds) + 's')
          }

          if (messageString && messageString.length > 0) {
            setListMessage(messageString)
            setMessage('Bidding Ends ' + messageString)
          }
          else {
            clearInterval(interval)
            setMessage('Bidding Closed')
            setListMessage('Bidding Closed')
          }


        }, 1000)
        return () => clearInterval(interval)
      }
      else if (checkDays < 0) {
        setMessage( "Bidding Closed")
        setListMessage('Bidding Closed')
      } else {
        setMessage( "Bidding Closed")
        setListMessage('Bidding Closed')
      }
    }
  }, [eventData?.eventbiddingclosedcst])


  const handleBeginPlayAnimation = () => {
    if (animationRef.current !== null) {
      const animation = createAnimation()
          .addElement(animationRef.current)
          .duration(1000)
          // .fromTo(
          //     'transform',
          //     'translateX(0)',
          //     'translateX(600px) '
          // ).fromTo('opacity', '1', '0.05')
          // .fromTo(
          //     'transform',
          //     'translateX(600px)',
          //     'translateX(0) '
          // )
          .fromTo('opacity', '1', '0')
          .easing('ease-out')
          .duration(1000)
          .fromTo('opacity', '0.01', '1')
          .easing('ease-in')

      animation.play();
    }
  };

  const getHighBidderText = (highbidder: string) => {
    // Hiding for now due to lack of time AUC-906
    // if (highbidder && highbidder?.length > 0) {
    //   return "High Bidder1: " + highbidder
    // }
    // else {
    //   return "No High Bidder"
    // }
    return ""
  }

  const getStatusText = (activeStateItem) => {
    if (activeStateItem?.quantityavailable > 0) {
      return currencyFormat(Number(activeStateItem?.lastbid))
    }
    else if (activeStateItem?.quantityunlimited) {
      return "Unlimited"
    }
    else {
      return "Sold Out"
    }
  }

  return (
    <>
      <ScreenWakeLock />
      <FullScreen handle={handle}>

      <Wrapper>
        <IonToolbar color={'white'}>
          <IonTitle className="ion-text-center">
            <Img
                alt="logo"
                src={eventData.logourl}
            />
          </IonTitle>
          {!handle.active &&
              <IonButtons slot="end">
                <IonButton id="notification-button" ion-button fill="clear" onClick={handle.enter}>
                  <IonIcon
                      // slot="icon-only"
                      icon={expandOutline}
                      style={{width: 24, height: 24, color: "#000000"}}
                  >
                  </IonIcon>
                </IonButton>
              </IonButtons>
          }
        </IonToolbar>
      </Wrapper>

      <IonLoading message={'Loading Auction Data...'} isOpen={loading}/>
      {!loading && auctionItems?.length <= 0 && (
        <IonCard ref={animationRef} style={{height: '90%'}}>
          <IonCardHeader class="ion-text-center">
                <IonCardTitle>
                  No items found. Please check your URL.
                </IonCardTitle>
          </IonCardHeader>
        </IonCard>
      )}
      {(activeStateItem && !list) &&
          <IonCard ref={animationRef} style={{height: '90%'}}>
            <IonCardHeader class="ion-text-center">
              <IonCardTitle style={{color: 'black', fontSize: 45}}>
                {location ? location + ' items' : 'All Items'}
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent style={{marginLeft: 25}}>
              <IonGrid>
                <IonRow>
                  <IonCol size={'4'}>
                    <IonImg className="card-image" src={activeStateItem?.imageurl} />
                  </IonCol>
                  <IonCol size={'1'}>

                  </IonCol>
                  <IonCol size={'7'}>
                    <IonRow>
                      <IonCardHeader  class="ion-text-left" style={{ paddingTop: 0}}>
                        <IonCardTitle style={{color: 'black', fontSize: 32}}>
                          {activeStateItem?.name}
                        </IonCardTitle>
                        {(activeStateItem && activeStateItem?.donatedby && activeStateItem?.donatedby.length > 0) &&
                            <IonCardTitle style={{color: 'gray', fontSize: 16, paddingTop: 10, paddingLeft: 10}}>
                              Donated By: {activeStateItem?.donatedby}
                            </IonCardTitle>
                        }
                        {/*<IonCardSubtitle style={{color: 'gray', fontSize: 22, paddingTop: 10, paddingLeft: 10, display: '-webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical',*/}
                        {/*  overflow: 'hidden', whiteSpace: 'break-spaces', maxHeight: 175}}>*/}
                        <IonCardTitle style={{color: 'gray', fontSize: 22, paddingTop: 10, paddingLeft: 10}}>
                          {activeStateItem?.description}
                        </IonCardTitle>
                      </IonCardHeader>
                    </IonRow>

                    <IonCardHeader class="ion-text-left" >
                      <IonRow>

                        <IonCol size={'6'}>
                          <IonCardTitle style={{color: 'black', fontSize: 32}}>
                            {getStatusText(activeStateItem)}
                          </IonCardTitle>
                        </IonCol>
                        <IonCol size={'3'} style={{paddingTop: 20}} class="ion-text-center">
                          <IonCardTitle style={{color: 'black', fontSize: 18}}>
                            {Number(activeStateItem?.buyitnowprice) > 0 &&
                                currencyFormat(Number(activeStateItem?.buyitnowprice))
                            }
                          </IonCardTitle>
                        </IonCol>
                        <IonCol size={'3'} style={{paddingTop: 20}} class="ion-text-center">
                          <IonCardTitle style={{color: 'black', fontSize: 18}}>
                            {Number(activeStateItem?.fairmarketvalue) > 0 &&
                                currencyFormat(Number(activeStateItem?.fairmarketvalue))
                            }
                          </IonCardTitle>
                        </IonCol>
                      </IonRow>
                      <IonRow>
                        <IonCol size={'6'} style={{paddingTop: 5}} >
                          {activeStateItem?.quantityavailable > 0 ?
                              <>
                                <IonCardTitle style={{color: 'gray', fontSize: 18}}>{activeStateItem?.numberofbids} Bids</IonCardTitle>
                                <IonCardTitle style={{color: 'gray', fontSize: 18}}>{activeStateItem?.quantityavailable} Available</IonCardTitle>
                              </>
                              :
                              <>
                                <IonCardTitle style={{color: 'gray', fontSize: 22}}>{getHighBidderText(activeStateItem?.highbidder)}</IonCardTitle>
                              </>
                          }
                        </IonCol>
                        <IonCol size={'3'} style={{paddingTop: 5}} class="ion-text-center">
                          {Number(activeStateItem?.buyitnowprice) > 0 &&
                              <IonCardTitle style={{color: 'gray', fontSize: 18}}>Buy It Now</IonCardTitle>
                          }
                        </IonCol>
                        <IonCol size={'3'} style={{paddingTop: 5}} class="ion-text-center">
                          {Number(activeStateItem?.fairmarketvalue) > 0 &&
                              <IonCardTitle style={{color: 'gray', fontSize: 18}}>Fair Market Value</IonCardTitle>
                          }
                        </IonCol>
                      </IonRow>
                      {activeStateItem?.quantityavailable > 0 &&
                          <IonRow>
                            <IonCol size={'12'} style={{paddingTop: 15}} >
                              <IonCardTitle style={{color: 'gray', fontSize: 22}}>{getHighBidderText(activeStateItem?.highbidder)}</IonCardTitle>
                            </IonCol>
                          </IonRow>
                      }
                    </IonCardHeader>
                    <IonCardHeader class="ion-text-left">
                      <IonCardTitle style={{color: 'black', fontSize: 32}}>
                        {message}
                      </IonCardTitle>
                    </IonCardHeader>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCardContent>
          </IonCard>
      }
      {(activeStateItem && list) &&
          <>
            <SlideshowDetailPage animationRef={animationRef} message={lstMessage} location={location} />
          </>
      }
      </FullScreen>
    </>
  )
}

export default SlideshowPage
